module.exports = __webpack_public_path__ + "img/brian.6118437f.png";